"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const StarEmpty = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), _react.default.createElement("path", {
  d: "M6.405 5.862a.73.73 0 0 1-.547.416l-3.568.546 2.581 2.63c.172.176.25.428.21.675l-.61 3.715 3.19-1.755a.699.699 0 0 1 .677 0l3.19 1.755-.609-3.715a.783.783 0 0 1 .21-.674l2.58-2.631-3.567-.546a.73.73 0 0 1-.547-.416L8 2.48 6.405 5.862zM5.27 4.83L7.348.424a.713.713 0 0 1 1.304 0L10.73 4.83l4.647.71c.596.092.834.859.402 1.299l-3.362 3.427.794 4.841c.102.622-.522 1.096-1.055.802L8 13.622 3.844 15.91c-.533.294-1.157-.18-1.055-.802l.794-4.841L.22 6.839c-.432-.44-.194-1.207.402-1.298L5.27 4.83z",
  className: "fill"
}));

var _default = StarEmpty;
exports.default = _default;